import * as React from 'react'

import Typography from '@mui/material/Typography'

import { LeadAssignmentRuleInfoPopover } from './LeadAssignmentRuleInfoPopover'
import { useInfoPopover } from '@user/components/Settings/LeadAssignmentRule/hooks'
import type { LeadAssignmentRule } from '../LeadAssignmentRuleForm/typings'

type Props = {
  label: string
  rule: LeadAssignmentRule
}

export function LeadAssignmentRuleInfoPopoverButton(props: Props) {
  const { label, rule } = props
  const { open, openPopover, closePopover, anchorEl } = useInfoPopover()

  return (
    <>
      <Typography
        variant="subtitle2"
        component="span"
        onClick={openPopover}
        sx={{ cursor: 'pointer' }}
        data-test-id="lead-assignment-rule-info-popover-button"
      >
        {label}
      </Typography>

      {anchorEl && (
        <LeadAssignmentRuleInfoPopover
          open={open}
          onClose={closePopover}
          popoverId="LeadAssignmentRuleInfoPopover"
          anchorEl={anchorEl}
          rule={rule}
        />
      )}
    </>
  )
}
